module.exports = __webpack_public_path__ + "static/media/outdoor shot 10000.0fe93406.webp";